import { commonAPI } from '@/services-ts/axios'
import type { IGetPopupNotificationList, IPayloadPopupNotification } from '@/types/Request'
import type { IPopupNotificationStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const usePopupNotificationStore = defineStore('popupNotification', {
  state: (): IPopupNotificationStore => ({
    popupNotifications: {
      data: [],
      total: 0,
    },
  }),

  actions: {
    async GetPopupNotificationList(payload: IGetPopupNotificationList) {
      const { status, data, total } =
        await commonAPI.PopupNotificationServices.GetPopupNotificationList(payload)
      this.popupNotifications = status
        ? { data: data || [], total: total || 0 }
        : { data: [], total: 0 }
    },

    async CreatePopupNotification(payload: IPayloadPopupNotification): Promise<boolean> {
      const { status, data } =
        await commonAPI.PopupNotificationServices.CreatePopupNotification(payload)
      if (status && data) {
        this.popupNotifications.data.push(data)
        this.popupNotifications.total += 1
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async UpdatePopupNotification(payload: IPayloadPopupNotification): Promise<boolean> {
      const { status, data } =
        await commonAPI.PopupNotificationServices.UpdatePopupNotification(payload)
      if (status && data) {
        const index = this.popupNotifications.data.findIndex(item => item.id === payload.Id)
        if (index !== -1) {
          this.popupNotifications.data[index] = data
        }
        void Alert({ message: Format('admin_global_updated'), type: 'success' })
      }
      return status
    },

    async DeletePopupNotification(id: string): Promise<boolean> {
      const { status } = await commonAPI.PopupNotificationServices.DeletePopupNotification(id)
      if (status) {
        this.popupNotifications.data = this.popupNotifications.data.filter(item => item.id !== id)
        this.popupNotifications.total -= 1
        void Alert({ message: Format('admin_global_deleted'), type: 'success' })
      }
      return status
    },
  },
})
